import { mqttEvent } from "./actions";
export function keepAliveReminderPattern() {
    return mqttEventTypePattern("KeepAliveReminder");
}
export function mqttEventTypePattern(type) {
    return (action) => action.type === mqttEvent.toString() && action.payload.type === type;
}
